import { DEFAULT_BUILD_NIGHTS, getDefaultOriginId } from '~/constants/default-origin';

/**
 * Single source of truth for the map "build a trip" entry point.
 *
 * `/map/build` requires query params to avoid hard 500 error. The seeded origin follows the
 * visitor's locale (see `getDefaultOriginId`), so the seeded href differs per locale.
 * TODO: remove `/map` deprecated page — all entry points go straight to the pre-seeded builder.
 */
const MAP_ENTRY_PATH = '/map/build';
const CMS_MAP_URL = 'https://www.byway.travel/map';
const LEGACY_MAP_PATH = '/map';

export const buildMapEntryHref = (locale?: string, extraParams?: Record<string, string>): string =>
  `${MAP_ENTRY_PATH}?${new URLSearchParams({
    origin: String(getDefaultOriginId(locale)),
    nights: DEFAULT_BUILD_NIGHTS,
    ...extraParams
  })}`;

/** True for any seeded builder href, whatever locale it was built for. */
export const isSeededMapEntryHref = (href: string): boolean => href.startsWith(`${MAP_ENTRY_PATH}?`);

export const resolveMapEntryHref = (url: string | null | undefined, locale?: string): string =>
  url === CMS_MAP_URL || url === LEGACY_MAP_PATH || url === MAP_ENTRY_PATH ? buildMapEntryHref(locale) : (url ?? '#');
